import type { PropsWithChildren } from "react";

const GradientBackground = ({ children }: PropsWithChildren<{}>) => {
	return (
		<>
			<div className="fixed h-full w-full bg-linear-to-b from-slate-900 via-sky-900 to-sky-600">
				<div className="pointer-events-none absolute -top-20 -right-15 h-72 w-72 rounded-full bg-white/5" />
				<div className="pointer-events-none absolute -bottom-15 -left-10 h-60 w-60 rounded-full bg-sky-300/10" />
			</div>

			<div className="relative h-full w-full">{children}</div>
		</>
	);
};

export default GradientBackground;
